exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".customerservice {\n  font-size: 1.15em;\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n  background: #f4f4f4;\n  text-align: center; }\n  .customerservice .content {\n    flex-direction: column; }\n  .customerservice .customerservice-title {\n    font-size: 3em;\n    font-weight: bold;\n    letter-spacing: 0.3px;\n    margin-bottom: 2.5rem;\n    line-height: 1; }\n  @media screen and (max-width: 576px) {\n    .customerservice {\n      padding-top: 4.5rem;\n      padding-bottom: 4.5rem; }\n      .customerservice .customerservice-title {\n        font-size: 1.8em; }\n      .customerservice h3 {\n        font-size: 1.2em; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/InfoCustomerService/InfoCustomerService.scss
// module id = 1703
// module chunks = 0